import React from 'react'
import { injectIntl } from 'react-intl'

const Address = ({intl}) => (
	<div>
    {/*<h3>Farang</h3>

    <address>
        <a href="https://www.google.fi/maps/place/Ainonkatu+3,+00100+Helsinki/" rel="noopener noreferrer">Ainonkatu 3</a><br />
        00100 Helsinki
    </address>

    <a href="mailto:info@farang.fi">info@farang.fi</a>
    <a href="tel:+358103229385">{intl.locale==='en'?'+358 ':'0'}10 322 9385</a>

    <a href="https://www.facebook.com/ravintola.farang/" className="some facebook">Facebook</a>
    <a href="https://www.linkedin.com/company/bw-restaurants-oy/" className="some linkedin">LinkedIn</a> */}
    </div>
)

export default injectIntl(Address);


// WEBPACK FOOTER //
// ./src/components/Address.js